<template>
  <base-select-search
    placeholder="Cari Kategori"
    :is-loading="loading"
    :data="data"
    :shadow="shadow"
    :fullwidth="fullwidth"
    :input-label="label"
    :inset="inset"
    label="name"
    v-model="selected"
    v-on:infinite-scroll="handleInfiniteScroll"
    v-on:search="handleSearch"
    v-on:change="handleChange"
  />
</template>

<script>
import BaseSelectSearch from '@/components/base/BaseSelectSearch.vue';
import { requestMixin } from '@/mixins/request/request';

export default {
  name: 'ArticleSelectSearch',
  mixins: [requestMixin],
  components: { BaseSelectSearch },
  props: {
    value: null,
    limit: {
      type: Number,
      default: 10,
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    fullwidth: Boolean,
    inset: Boolean,
    label: String
  },
  emits: ['input', 'change'],
  data: function () {
    return {
      search: null,
      size: null,
      loading: false,
      articleCategories: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    selected: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    data() {
      return this.articleCategories.data.map(bank => ({ id: bank.id, attributes: { name: bank.attributes.name } }))
    }
  },
  methods: {
    init: function () {
      this.size = this.limit;

      this.loadCategories();
    },
    loadCategories: async function () {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/article-categories', {
        params: {
          'page[size]': this.size,
          'filter[search]': this.search,
          'fields[article-categories]': 'name',
        },
      });

      if (!error) {
        this.articleCategories = res;
      }

      this.loading = false;
    },
    handleInfiniteScroll: function () {
      if (this.size < this.articleCategories.meta.page.total) {
        this.size += this.limit;

        this.loadCategories();
      }
    },
    handleSearch: function (search) {
      this.size = this.limit;
      this.search = search;

      this.loadCategories();
    },
    handleChange: function () {
      this.$emit('change');
    },
  },
  created: function () {
    this.init();
  },
};
</script>
